export class WindowSizeCalculationModel {
    public screenHeight: number; 
    public screenWidth: number;
    constructor() 
    {
        this.screenHeight = window.innerHeight;
        this.screenWidth = window.innerWidth;
    }
}